import React from "react";
import { Box, Button, Divider, Skeleton, Typography } from "@mui/joy";
import { CloudUpload, EllipsisVertical, FileDown } from "lucide-react";
import { IconButton } from "../../shared";

interface IDocumentPreviewWidget {
    title: string;
    description: string;
    onDownloadClick?: () => any;
    onPrintClick?: () => any;
    onPreviewClick?: () => any;
    backgroundLayer?: boolean;
}
export default function DocumentUploadWidget(props: IDocumentPreviewWidget) {
    const { title, description, backgroundLayer } = { ...props };
    return (
        <Box
            sx={{
                width: 230,
                height: 280,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
            }}
        >
            {/* Background Layer */}
            {backgroundLayer && (
                <Box
                    sx={{
                        width: 200,
                        height: 250,
                        //bgcolor: "green",
                        border: "1px dashed #ddd",
                        borderRadius: "lg",
                        position: "absolute",
                        background: "linear-gradient(169deg, #f8d8d8 -60%, transparent 70%)",
                        top: 0,
                        left: 0,
                        zIndex: 0,
                        transform: "rotate(-2deg)",
                    }}
                >
                    <Box display={"flex"} flexDirection={"column"} gap={1} p={1}>
                        <Line width={"50%"} />
                        <Line />
                        <Line />
                        <Line />
                        <Line bgcolor={"success.solidBg"} />
                        <Line />
                        <Line />
                        <Line />
                        <Line />
                        <Line />
                        <Line />
                        <Line />
                        <Line />
                        <Line />
                    </Box>
                </Box>
            )}

            {/* Top Layer with Fold */}
            <Box
                sx={(theme: any) => {
                    return {
                        width: 200,
                        height: 250,
                        bgcolor: theme.palette.background.surface,
                        border: "1px dashed #ddd",
                        borderRadius: "lg",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1,
                        position: "relative",
                        //boxShadow: "lg",
                        overflow: "hidden",
                        flexDirection: "column",
                        p: 2,
                        textAlign: "center",
                    };
                }}
            >
                <CloudUpload size={24} />
                <Box mt={2}>
                    {/* <Divider inset="context" sx={{ mb: 1 }} /> */}
                    <Typography level="body-sm" sx={{ fontWeight: 600 }} gutterBottom>
                        {title}
                    </Typography>
                    <Typography level="body-sm" gutterBottom color="success">
                        Click here/drag & drop
                    </Typography>
                    <Typography level="body-xs" gutterBottom>
                        {description}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
}

function Line(props: any) {
    return (
        <Box
            sx={(theme: any) => {
                let bgColor = "divider";

                if (props.bgcolor) {
                    const [key, subkey] = props.bgcolor.split(".");
                    bgColor = theme.palette[key]?.[subkey] || "divider";
                }

                return {
                    height: 6,
                    width: "100%",
                    borderRadius: "lg",
                    ...props,
                    bgcolor: bgColor,
                };
            }}
        />
    );
}
